import type { FeatureFlagMap as FlagMap } from "@/lib/feature-flags/flags";

import { getEnterpriseSlugFromPath } from "@/dashboard/features/analytics/lib/api-base";
import { fetchJson } from "@/dashboard/hooks/api/fetch-json";
import { useTenantQuery } from "@/dashboard/hooks/query/use-tenant-query";

/* ------------------------------------------------------------------ */
/* Key builders                                                       */
/* ------------------------------------------------------------------ */

export const featureFlagsKey = () => ["feature-flags"] as const;

/* ------------------------------------------------------------------ */
/* Helpers                                                            */
/* ------------------------------------------------------------------ */

function getFeatureFlagsUrl(): string {
  const slug = getEnterpriseSlugFromPath();
  if (slug) {
    return `/api/enterprise/${slug}/feature-flags`;
  }
  return "/api/dashboard/feature-flags";
}

/* ------------------------------------------------------------------ */
/* Hook                                                               */
/* ------------------------------------------------------------------ */

export function useFeatureFlagsQuery(enabled: boolean) {
  return useTenantQuery<FlagMap>({
    queryKey: featureFlagsKey(),
    queryFn: () => fetchJson<FlagMap>(getFeatureFlagsUrl()),
    enabled,
    staleTime: 30_000,
  });
}
